import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LocationDTO } from '../../../../locations-map/models/LocationDTO';
import { FilterMapComponent } from '../../../../locations-map/components/filters-map/filter-map.component';
import { MatDialog } from '@angular/material/dialog';
import { PanelLocationsService } from '../../../../locations-map/services/Panel-Locations.service';
import { PopupReportHistorialService } from '../../../../locations-map/services/Popup-Report-Historial.service';
import { CitronellaActionsService } from '../../../services/ServiceCatalogEncapsulators/CitronellaActions.service';
import { GeoClustersFrecuencyPlacesService } from '../../../../locations-map/services/GeoClustersFrecuencyPlaces.service';
import { ConfirmDialogService } from '../../confirm-dialog/services/Confirm-Dialog.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { GeofencesService } from 'src/app/features/geofences-map/services/Geofences.service';
import { PanelAddGeofencesService } from 'src/app/features/geofences-map/services/Panel-Add-Geofences.service';
import { PanelDetailLocationsService } from 'src/app/features/locations-map/services/Panel-Detail-Locations.service';
import { ValetParkingService } from 'src/app/features/locations-map/services/ValetParking.service';
import { GroupStepRouteDTO } from 'src/app/features/routeMap/models/GroupStepRouteDTO';
import { IRouteMapRequest } from 'src/app/features/routeMap/models/IRouteMapRequest';
import { ResumeRouteMapDTO } from 'src/app/features/routeMap/models/ResumeRouteMapDTO';
import { StepDetailsRouteDTO } from 'src/app/features/routeMap/models/StepDetailsRouteDTO';
import { PanelResumeRouteService } from 'src/app/features/routeMap/services/Panel-Resume-Route.service';
import { RouteFilterService } from 'src/app/features/routeMap/services/Route-Filter.service';
import { RouteMapService } from 'src/app/features/routeMap/services/Route-Map.service';
import { MapHelperService } from 'src/services/map-helper.service';
import { EstatusJSON } from '../../../models/EstatusJSON';
import { MapService } from '../../../services/Map.service';
import { SignalUserService } from '../../../services/ServiceCatalogEncapsulators/Signal-User.service';
import { SessionService } from '../../../services/Session.service';
import { SwalNotificationService } from '../../../services/SwalNotification.service';
import { CarouselPopupComponent } from '../../carousel/components/carousel-popup/carousel-popup.component';
import { MessageDialogService } from '../../message-dialog/services/message-dialog.service';
import { IRequestMapRouteForm } from '../../report-list/models/IRequestMapRouteForm';
import { RouteSheetService } from 'src/app/features/locations-map/services/RouteSheet.service';
import { NotificationsToastService } from '../../../services/Notifications-Toast.service';
import { AssignmentService } from '../../../services/ServiceCatalogEncapsulators/Assigment.service';

@Component({
  selector: 'location-button-toolbar',
  templateUrl: './location-button-toolbar.component.html',
  styleUrls: ['./location-button-toolbar.component.css']
})
export class LocationButtonToolbarComponent {

  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";

  //Hardcodeado para branding e ingenieros
  isBranding : boolean = false;
  hasServiceAsignation : boolean = false;
  @Output() valetParkingDeleteResponse = new EventEmitter<boolean>();

  isLoadingButton: boolean = false;
  @Input() isLoadingParent: boolean = false;

  //output para accion de cargar
  @Output() loadEmiter = new EventEmitter<boolean>();

  //inputs para modificar opciones de herramientas
  @Input() isGlobal: boolean = false;
  @Input() identifier: any;
  @Input() isFromLocation: boolean = false;
  

  //inputs para la lista de excel
  @Input() btnDownExcel: boolean = false;
  @Input() isLocationFilter: boolean = false;
  @Input() filterLocationList: LocationDTO[] = [];
  @Input() excelDownloadOperation: string;
  @Input() idLocationCategory: number;

  //inputs y outputs para el filtro
  @Input() filtersObject: any;
  @Input() ApplyFilter: boolean = false;
  @Input() AvailabilityFiltersObject: any;
  @Input() ApplyAvailabilityFilter: boolean = false;
  @Output() filterResponse = new EventEmitter<any>();
  @Output() availabilityFilterResponse = new EventEmitter<any>();

  //inputs para valet parking
  @Input() hasValetParking: boolean = false;
  @Input() isValetParking: boolean = false;
  @Input() valetParkingGuid: string = "";
  @Output() valetParkingCreateResponse = new EventEmitter<any>();

  //inputs para geocercas
  @Input() isGeofencePanel: boolean = false;
  @Input() isGeofenceDetails: boolean = false;
  @Input() geofenceGuid: string = "";

  //inputs para routes
  locationRequest: IRequestMapRouteForm = {
    vehiculo: undefined,
    startDate: new Date(),
    endDate: new Date(),
  };
  @Input() isDetailLocations: boolean = false;
  @Input() isMonitor: boolean = true;
  @Input() images: string[] = [];
  @Input() isLoadingImages: boolean = false;

  //inputs para Bloqueo
  @Input() blockingObject: { isVisibleBlocking: boolean, blockingIcon: string};

  //inputs para streetView
  @Input() CordX: string = "";
  @Input() CordY: string = "";

  //para recargar panel de detalles
  @Input() isReloadable: boolean = false;

  suscription_postLocationsToExcel: Subscription;
  Subscription_AfterClosed: Subscription;
  subscription_findByIdentifier: Subscription;
  subscription_routeFilterService: Subscription;
  suscription_createBlokingRequest: Subscription;
  suscription_delete: Subscription;
  suscription_confirmDialogService: Subscription;
  suscription_valetParkingDelete: Subscription;

  constructor(private popupReportHistorialService: PopupReportHistorialService,
    private notifyService: SwalNotificationService,
    private sessionService: SessionService,
    public dialog: MatDialog,
    private panelLocationsService: PanelLocationsService,
    private panelDetalilService: PanelDetailLocationsService,
    private routeFilterService: RouteFilterService,
    private routeMapService: RouteMapService,
    private panelResumeRouteService: PanelResumeRouteService,
    private mapHelper: MapHelperService,
    private signalUserService: SignalUserService,
    private mapService: MapService,
    private valetParkingService: ValetParkingService,
    private geofenceService: GeofencesService,
    private panelAddGeofenceService: PanelAddGeofencesService,
    private confirmDialogService: ConfirmDialogService,
    private citronellaActionsService: CitronellaActionsService,
    private messageDialogService: MessageDialogService,
    private panelGeofenceDetailService: PanelDetailLocationsService,
    public geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    private routeSheetService: RouteSheetService,
    private notifyToastService: NotificationsToastService,
    private assignmentService: AssignmentService) {
      if(this.sessionService.Customer == undefined || this.sessionService.Customer == null)         
        this.sessionService.getCustomerId();
      this.blockingObject = { isVisibleBlocking: false, blockingIcon: "lock" };

      if(localStorage.getItem("ClienteSeleccionadoId") == "26797ce1-d5b1-4446-8fdb-8967ee7c3ad5"){
        this.isBranding = true;
      };

      if(true){
        this.hasServiceAsignation = true;
      };
    }

    ngOnDestroy() {
      if (this.suscription_postLocationsToExcel)
        this.suscription_postLocationsToExcel.unsubscribe();
      if (this.suscription_confirmDialogService)
        this.suscription_confirmDialogService.unsubscribe();
      if (this.Subscription_AfterClosed)
        this.Subscription_AfterClosed.unsubscribe();
      if (this.subscription_findByIdentifier)
        this.subscription_findByIdentifier.unsubscribe();
      if (this.subscription_routeFilterService)
        this.subscription_routeFilterService.unsubscribe();
      if (this.suscription_createBlokingRequest)
        this.suscription_createBlokingRequest.unsubscribe();
      if (this.suscription_delete)
        this.suscription_delete.unsubscribe();
      if (this.suscription_valetParkingDelete)
        this.suscription_valetParkingDelete.unsubscribe();

      // this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible = false;
      // this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
    }

  // duplicado de report-list temporal (?) para pruebas

  getExcel(){
    this.notifyService.confirmMessage("Descargar excel", "Seguro que quieres descargar la lista de activos en excel?").then((result) => {
      if (result.value) {
        this.ShowDownloadingMessage();
        if (!this.isLocationFilter) {
          this. suscription_postLocationsToExcel = this.popupReportHistorialService.postLocationsTabToExcel(this.excelDownloadOperation, this.idLocationCategory, "", this.filtersObject.selected).subscribe((data) =>{
          
            if (data.isSuccess == true) {
              // Decodificar los datos que trae como string del servidor
              const byteCharacters = atob(data.result);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
      
              const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'Lista_de_activos.xlsx'; 
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.notifyService.MessageSuccessful(
                "Archivo Descargado",
                "Se han descargado los activos en un excel"
              );
            }
            else{
              this.notifyService.MessageError(
                "Archivo no descargado, No hay datos"
              );
            }
          });
        }else{
          this. suscription_postLocationsToExcel = this.popupReportHistorialService.postLocationsVinListToExcel(this.filterLocationList).subscribe((data) =>{
          
            if (data.isSuccess == true) {
              // Decodificar los datos que trae como string del servidor
              const byteCharacters = atob(data.result);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
      
              const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'Lista_de_locacion.xlsx'; // Nombre del archivo según sea necesario
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              this.notifyService.MessageSuccessful(
                "Archivo Descargado",
                "Se han descargado los activos en un excel"
              );
            }
            else{
              this.notifyService.MessageError(
                "Archivo no descargado, No hay datos"
              );
            }
          });
        }
      }
    });
  }

  openFilter(): void {
    console.log("filtersObject",this.filtersObject);
    
    let dialogRef = this.dialog.open(FilterMapComponent, {
      data: { filters: this.filtersObject.filters, selected: this.filtersObject.selected, hasAvailability: false, selectedInitialDate: null, selectedFinalDate: null },
      disableClose: false,
      width: "40vw",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
    });
   this.Subscription_AfterClosed = dialogRef.afterClosed().subscribe((res) => {
      if (res.search) {
        this.filterResponse.emit(res);
      }
    });
  }

  openAvailabilityFilter(): void {
    console.log("AvailabilityFiltersObject",this.AvailabilityFiltersObject);
    
    let dialogRef = this.dialog.open(FilterMapComponent, {
      data: { filters: this.AvailabilityFiltersObject.filters, selected: this.AvailabilityFiltersObject.selected, isAvailabilityFilter: true , selectedInitialDate: this.AvailabilityFiltersObject.startDate, selectedFinalDate: this.AvailabilityFiltersObject.endDate, selectedCategories: this.AvailabilityFiltersObject.idLocationCategories },
      disableClose: false,
      width: "20vw",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
    });
   this.Subscription_AfterClosed = dialogRef.afterClosed().subscribe((res) => {
      if (res.search) {
        this.availabilityFilterResponse.emit(res);
      }
    });
  }

  getLocationRoute() {
    this.isLoadingButton = true;
    this.subscription_findByIdentifier = this.routeFilterService.findByIdentifier(this.identifier).subscribe((arg) => {
      if (this.identifier.length == 17) {
        this.locationRequest.vehiculo = arg.result[0];
        this.routeFilterService.setVehiculo( arg.result[0]);
      }
      console.log("buscando...");

      this.locationRequest.startDate = new Date();
      this.locationRequest.endDate = new Date();
      console.log("request vehiculo identifier", this.locationRequest);
  
      if (
        this.locationRequest.vehiculo &&
        this.locationRequest.startDate &&
        this.locationRequest.endDate
      ) {
        try {
          const startDate = new Date(this.locationRequest.startDate);
          const endDate = new Date(this.locationRequest.endDate);
          startDate.setHours(this.locationRequest.startDate.getHours() - 6);
          startDate.setDate(this.locationRequest.startDate.getDate() - 1);
          endDate.setHours(this.locationRequest.endDate.getHours() - 6);
          var requestRouteMap: IRouteMapRequest = {
            Identifier: this.locationRequest.vehiculo.identifier,
            StartDate: startDate.toISOString(),
            EndDate: endDate.toISOString(),
            StartHour: null,
          };
  
          console.log("updating...");
  
          this.getRouteMapService(requestRouteMap);
        } catch (error) {
          // this.request.startDate = null;
          console.log(error);
          this.isLoadingButton = false;
        }
      }else{
        this.isLoadingButton = false;
      }
    });
            
    
  }

  getRouteMapService(routeMapRequest: IRouteMapRequest) {

    this.subscription_routeFilterService = this.routeFilterService.getRouteData(routeMapRequest).subscribe(
      (resp) => {
        if (resp.isSuccess) {
          var resumeRoute = resp.result.resumeRouteMapDTO as ResumeRouteMapDTO;
          var detailsRoute = resp.result
            .detailsRouteDTO as StepDetailsRouteDTO[];
          var groupedRoute = resp.result
            .groupStepsRouteDTO as GroupStepRouteDTO[];
          if (resumeRoute != null) {
            
            if (resumeRoute.cantStops != null && resumeRoute.cantStops != "0" ) {
              //Close Locations
              this.isLoadingButton = false;
              this.panelLocationsService.setVisibilityPanel(false);
              this.panelDetalilService.setVisibilityPopup(false);
              this.signalUserService.UnsubscribeSignalUserIdentifierService(this.identifier);
              this.mapService.UpdateLayerGeoJson(
                "locationActiveSource",
                this.mapService.Empty_GeoJson
              );

              //open routes
              this.routeMapService.showRouteMapLayers();
              this.panelResumeRouteService.setVisibilityPopup(true);
              this.panelResumeRouteService.setResume(resumeRoute);
              this.panelResumeRouteService.setDetails(detailsRoute);
              this.panelResumeRouteService.setGrouped(groupedRoute);
              console.log("groupedRoute", groupedRoute);
              this.mapHelper.SetBounds(JSON.parse(resumeRoute.sGeojsonResume));
              //this.panelResumeRouteService.setRequest(request);
              this.routeMapService.updateRouteMap(resumeRoute.sGeojsonResume);
            } else {
              
              this.isLoadingButton = false;
              this.notifyToastService.showInfo(
                "por favor acceda desde Rutas para filtrar por otro rango de fechas",
                "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
              );
            }
          } else {
            
            this.isLoadingButton = false;
            this.notifyToastService.showInfo(
              "por favor acceda desde Rutas para filtrar por otro rango de fechas",
              "La Trazabilidad de Ruta para éste carro al día de ayer no fue encontrada"
            );
          }
        } else {
          this.isLoadingButton = false;
          // this.toastrService.error("Internal Error", elements.errors.toString());
        }
      },
      (error) => {
        console.log("location route error",error);
        this.isLoadingButton = false;
      }
    );
  }

  ValetParking(){
    if (this.isValetParking) {
      this.notifyService.confirmMessage("Eliminar", "Seguro que quieres eliminar el valet parking?").then((result) => {
        if (result.value) {
          this.suscription_valetParkingDelete = this.geofenceService.FullDelete(this.valetParkingGuid).subscribe((data)=>{
            if(data.isSuccess == true){
              this.notifyService.MessageSuccessful("Borrado","Valet Parking Borrado exitosamente");
              this.valetParkingDeleteResponse.emit(true);
            }else{
              this.notifyService.MessageError("Problema al eliminar el Valet Parking");
            }
          });
        }
      });
    }else{
      var dialog = this.valetParkingService.openDialog(this.identifier);
      dialog.afterClosed().subscribe((isCreated) => {
        if (isCreated)
          this.valetParkingCreateResponse.emit(isCreated);
      });
    }
  }

  OpenBlokingDialog() {
      const state = this.blockingObject.blockingIcon == "lock" ? "desbloqueo" : "bloqueo";
      const title = `Solicitud de ${state}`;
      const message = `¿Desea realizar una solicitud de '${state}' para el activo '${this.identifier}'?`;

      this.suscription_confirmDialogService = this.confirmDialogService
        .show(title, message)
        .subscribe((result) => {
          if (result) {
            this.isLoadingButton = true;
            this.suscription_createBlokingRequest = this.citronellaActionsService
              .createBlokingRequest(this.identifier)
              .subscribe((data: EstatusJSON) => {
                this.messageDialogService.show(title, data.message);
                if (data.isSuccess) {
                  this.panelDetalilService.setBlokingIcon(data.result.locked);
                }else{
                  this.notifyService.MessageError("Problema al bloquear el auto, comuniquese con el administrador");
                }
                this.isLoadingButton = false;
              });
          }
        });
  }

  onClickAddGeofence(){
    this.panelAddGeofenceService.$guidEditable = "";
    this.panelAddGeofenceService.$isDuplicate = false;
    this.geofenceService.setVisiblePanelGeofences(false);
    //selecciona el panel de agregar geocerca
    this.geofenceService.setVisiblePanelEditGeofences(true);
  }

  onClickEditGeofence(){
    this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
    this.panelAddGeofenceService.$isDuplicate = false;
    this.geofenceService.setVisiblePanelGeofences(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    //selecciona el componnte de edicion
    this.geofenceService.setVisiblePanelEditGeofences(true);
  }

  onClickDuplicateGeofence(){
    this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
    this.panelAddGeofenceService.$isDuplicate = true;
    this.geofenceService.setVisiblePanelGeofences(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    //selecciona el componente de edicion
    this.geofenceService.setVisiblePanelEditGeofences(true);
  }

  onClickDeleteGeofence(){
    var resp = this.notifyService.confirmMessage("Borrado","¿Seguro que desea borrar esta geocerca ?");
    resp.then((result) =>{
       if(result.value)
       {
          // window.open(urlb,'_blank');
          this.suscription_delete = this.geofenceService.delete(this.geofenceGuid).subscribe((data)=>{
            console.log("Data ",data);
            if(data.isSuccess == true){
              this.notifyService.MessageSuccessful("Borrado","Registro Borrado exitosamente");
              this.OpenGeofencePanel();
              this.mapHelper.FlyToCamera( this._CENTER_LAT, this._CENTER_LNG, this._CENTER_ZOOM);
            }else{
              this.notifyService.MessageError("Problema al eliminar el registro");
            }
          });
        }
     }); 
    this.panelAddGeofenceService.$guidEditable = this.geofenceGuid;
    this.geofenceService.deleteGeofence(this.geofenceGuid);
  }

  OpenGeofencePanel(){
    this.panelGeofenceDetailService.setVisibilityPopup(false);
    this.geofenceService.setVisiblePanelDetailGeofences(false);
    this.geofenceService.setVisiblePanelGeofences(false);
    setTimeout(() => {
      this.geofenceService.setVisiblePanelGeofences(true);
    }, 1000);
  }

  refreshDetails(){
    this.mapService.UpdateLayerGeoJson(
      "locationCarActiveSource",
      this.mapService.Empty_GeoJson
    );
    // this.routeSheetService.isForceReload = true;
    this.mapHelper.onFocusPin(this.identifier, true);
  }

  // para popup de imagenes
  openCarouselPopup() {
    const diag = this.dialog.open(CarouselPopupComponent, {
      width: '60vw',
      height: 'fit-content',
      data: { 
        images: this.images,
        currentIndex: 0,
      },
      // panelClass: 'custom-dialog-container'
    });

    diag.backdropClick().subscribe(result => {
      diag.close();
    });
  }

  // para popup de imagenes
  openStreetView() {
    this.mapService.loadStreetView(this.CordX, this.CordY);
  }

  ShowDownloadingMessage() {
    var resp = this.notifyService.MessageDownloading();
    resp.then(d=>{
      if(d.isConfirmed){
        this.notifyToastService.showInfoExtended("","Procesando solicitud de descarga...");
      }});
  }

  // para el componente de lugares recurrentes
  // openRecurrentPlaces(){
  //   this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(!this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible);
  //   if(this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible){
  //     this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = this.identifier;
  //   }else{
  //     this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
  //   }
  // }

 
  startAssignment(){
    this.notifyService.confirmMessage("Asignar servicios a los ingenieros", "Una vez se inicie el proceso, se bloquearan los controles hasta que termine, ¿Comenzar?").then((result) => {
      if (result.value) {
        this.assignmentService.GetLastCalculateAllEngineersUI().subscribe((data: EstatusJSON) => {
          if (data.isSuccess && data.result != null) {
            this.notifyToastService.showWarning("Asignación de servicios","Iniciando el proceso de asignación de servicios");
            this.assignmentService.regionsGeometries = data.result.geoJsonRegions;
            this.assignmentService.zonesGeometries = data.result.geoJsonZones;
            this.assignmentService.clustersGeometries = data.result.geoJsonClusters;
            this.assignmentService.servicesGeometries = data.result.geoJsonServices;
            console.log("data.result", data.result);
            
            console.log("regionsGeometries", this.assignmentService.regionsGeometries);
            console.log("zonesGeometries", this.assignmentService.zonesGeometries);
            console.log("clustersGeometries", this.assignmentService.clustersGeometries);
            console.log("geoJsonServices", this.assignmentService.servicesGeometries);
            this.assignmentService.SetAssigning(true);
          }else{
            this.notifyService.MessageError("Problema al asignar los servicios, comuniquese con el administrador");
          }
        });
      }
    });
  }
}
